export default __webpack_public_path__ + "static/media/spaces_in_bangalore_256.56ef4f41.jpg";